import DataVTabs from './datav-tabs';
export default DataVTabs;
